<template>
    <div class="container" style="margin-top: 90px;">
        <h4 class="d-flex justify-content-center"><b style="color: green;">CANDIDATE LIST</b></h4>
        <div v-if="academicCandidates.length > 0" class="my-3 container mx-3">
            <h4 class="text-start" style="color: grey;"><b>Academic Staff</b></h4>
            <div  class="mt-2 text-start">
                <h5><b>Candidates to Appraise:</b></h5>
                <h6 class="names" v-for="candidate, candidateIndex in academicCandidates">
                    <router-link :to="'/candidate/' + candidate._id + token">
                        ({{ candidateIndex + 1 }}) {{ candidate.name }}
                    </router-link>
                </h6>
            </div>
        </div>
        <div class="mt-4" v-if="academicCandidates.length <= 0">
            <b>No candidates to assess in your faculty</b>
        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'academiccandidatelist',
    emits: ['toggleLoader'],
    data() {
        return {
            faculty: '',
            academicCandidates: [],
            token: ''
        }
    },
    mounted(){
        var faculty = ''
        
        if (this.$route.params.faculty == 'agr') { 
            faculty = 'Agriculture'
        }

        if (this.$route.params.faculty == 'bms') { 
            faculty = 'Basic Medical Sciences'
        }

        if (this.$route.params.faculty == 'bcs') { 
            faculty = 'Basic Clinical Sciences'
        }

        if (this.$route.params.faculty == 'cs') { 
            faculty = 'Clinical Sciences'
        }

        if (this.$route.params.faculty == 'cms') { 
            faculty = 'Communication and Media Studies'
        }

        if (this.$route.params.faculty == 'eng') { 
            faculty = 'Engineering'
        }

        if (this.$route.params.faculty == 'edu') { 
            faculty = 'Education'
        }

        if (this.$route.params.faculty == 'env') { 
            faculty = 'Environmental Sciences'
        }

        if (this.$route.params.faculty == 'hum') { 
            faculty = 'Humanities'
        }

        if (this.$route.params.faculty == 'law') { 
            faculty = 'Law'
        }

        if (this.$route.params.faculty == 'am') { 
            faculty = 'Administration and Management'
        }
        
        if (this.$route.params.faculty == 'sci') { 
            faculty = 'Science'
        }

        if (this.$route.params.faculty == 'ss') { 
            faculty = 'Social Sciences'
        }

        if (this.$route.params.faculty == 'mls') { 
            faculty = 'Medical Laboratory Science'
        }

        this.getCandidates(faculty)
    },
    methods: {
        async getCandidates(faculty) {
            if (faculty != '') {
                this.$emit('toggleLoader');

                this.token = this.$route.query.token ? '?token=' + this.$route.query.token : '';

                var details = {
                    faculty: faculty
                }

                const candidates = await DataService.getCandidatesThatSubmitted(details);

                if (candidates) {
                    if (candidates.length > 0) {
                        this.academicCandidates = candidates.filter(candidate => (candidate.staffType == 'Academic Teaching' || candidate.staffType == 'Research'))
                    } else {
                        this.academicCandidates = [];
                    }
                }

                this.$emit('toggleLoader');
            }
        }
    }
}
</script>